import PropTypes from 'prop-types'
import React from 'react'
import { Map } from 'immutable'
import _partial from 'lodash/partial'
import _isFunction from 'lodash/isFunction'
import _times from 'lodash/times'
import ImmutablePropTypes from 'react-immutable-proptypes'
import CommentsHeader from '../CommentsHeader/index'
import CommentThread from '../CommentThread/index'
import CommentsEmpty from '../CommentsEmpty/index'
import CommentPlaceholder from '../CommentPlaceholder/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import useComments from '../../services/comments/useComments'

function handleOnClickClose (props) {
  const { onClickClose, setCommentsVisible } = props
  setCommentsVisible(false)
  if (_isFunction(onClickClose)) {
    onClickClose()
  }
}

function renderCommentsList (opts) {
  const {
    comments, loading, auth, createComment, updateComment, reportComment,
  } = opts
  if (loading) {
    return (
      <div className="comments__list">
        {_times(2, (i) => (
          <div key={`placeholder-${i}`} className="comment-thread comment-thread--placeholders">
            <CommentPlaceholder />
          </div>
        ))}
      </div>
    )
  }
  if (comments.length === 0) {
    return <CommentsEmpty />
  }
  return (
    <div className="comments__list">
      {comments.map((comment, index) => (
        <CommentThread
          comment={comment}
          key={`comments-${comment.id || index}`}
          auth={auth}
          createComment={createComment}
          updateComment={updateComment}
          reportComment={reportComment}
        />
      ))}
    </div>
  )
}

function Comments (props) {
  const {
    comments: commentsState, auth, location, contentId,
  } = props
  const metadata = commentsState.get('metadata', Map())

  const {
    comments, loading, createComment, updateComment, reportComment,
  } = useComments({ contentId, auth })

  return (
    <aside className={`comments${commentsState.get('visible') ? ' comments--open' : ''}`}>
      <Button
        type={TYPES.LINK}
        onClick={_partial(handleOnClickClose, props)}
        className="comments__close-button"
      >
        <IconV2
          className="comments__close-icon"
          type={ICON_TYPES.CLOSE}
        />
      </Button>
      <div className="comments__body">
        <CommentsHeader
          auth={auth}
          data={metadata}
          location={location}
          createComment={createComment}
          updateComment={updateComment}
        />
        {renderCommentsList({
          comments, loading, auth, createComment, updateComment, reportComment,
        })}
      </div>
    </aside>
  )
}

Comments.propTypes = {
  comments: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setCommentsVisible: PropTypes.func.isRequired,
  onClickClose: PropTypes.func,
  location: PropTypes.object,
}

export default Comments
